import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Tooltip,
} from 'chart.js';

// Plugin to render the value on top of each bar
const labelPlugin = {
  id: 'barLabel',
  afterDatasetsDraw: chart => {
    const { ctx } = chart;
    ctx.save();
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((bar, index) => {
        const value = dataset.data[index];
        if (value == null) return;
        ctx.fillStyle = '#fff';
        ctx.font = '10px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(Number.parseFloat(value).toFixed(1), bar.x, bar.y - 3);
      });
    });
    ctx.restore();
  },
};

ChartJS.register(CategoryScale, LinearScale, BarElement, Legend, Tooltip);

function DualBarGroupChart({ data = [], datasetLabels = ['Initial', 'Current'], max = 250, yLabel = '' }) {
  const labels = data.map(d => d.label);
  const initialVals = data.map(d => d.initial);
  const currentVals = data.map(d => d.current);

  const chartData = {
    labels,
    datasets: [
      {
        label: datasetLabels[0] || 'Initial',
        data: initialVals,
        backgroundColor: '#808080',
        borderColor: '#808080',
        borderWidth: 1,
        borderSkipped: false,
        borderRadius: { topLeft: 4, topRight: 4 },
        barPercentage: 1,
        categoryPercentage: 0.6,
      },
      {
        label: datasetLabels[1] || 'Current',
        data: currentVals,
        backgroundColor: '#3b82f6',
        borderColor: '#3b82f6',
        borderWidth: 1,
        borderSkipped: false,
        borderRadius: { topLeft: 4, topRight: 4 },
        barPercentage: 1,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#fff',
          font: { size: 12 },
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },
    },
    scales: {
      x: {
        stacked: false,
        grid: { display: false },
        ticks: { color: '#fff', font: { size: 10 } },
      },
      y: {
        beginAtZero: true,
        max: max,
        ticks: {
          stepSize: max / 5,
          color: '#fff',
        },
        grid: { color: '#444' },
        title: {
          display: !!yLabel,
          text: yLabel,
          color: '#fff',
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <div className="w-full h-full relative">
      <Bar
        data={chartData}
        options={options}
        plugins={[labelPlugin]}
        height={null}
        width={null}
      />
    </div>
  );

}

export default DualBarGroupChart;
